module.exports = __webpack_public_path__ + "static/media/lock.6955fdd6.svg";